import { render } from "./observer.vue?vue&type=template&id=c2bd33ec&scoped=true"
import script from "./observer.vue?vue&type=script&lang=js"
export * from "./observer.vue?vue&type=script&lang=js"

import "./observer.vue?vue&type=style&index=0&id=c2bd33ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c2bd33ec"

export default script